import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { DidGroupRenameInfo } from '@components/Capacity/DidGroups/Rename';
import { DidGroupRenameForm } from '@components/Capacity/DidGroups/Rename/DidGroupRenameForm';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page404, Page500 } from '@containers/ErrorPages';
import { didGroupsApi } from '@reducers/capacity';

export const Rename = () => {
  const { id } = useParams();
  const didGroupDetails = didGroupsApi.useGetDetailsQuery({
    id,
  });

  if (didGroupDetails.isLoading || didGroupDetails.isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (didGroupDetails.isError) {
    return <Page500 />;
  }
  if (!didGroupDetails.data) {
    return <Page404 />;
  }
  return (
    <>
      <Card className="mb-2">
        <Card.Header className="bg-didxl text-white">
          Rename DID-Group: {didGroupDetails.data.country},{' '}
          {didGroupDetails.data.plan}, DID-Group -{' '}
          <span className="fw-bold">{didGroupDetails.data.name}</span>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <DidGroupRenameForm />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header className="bg-didxl text-white" />
        <Card.Body>
          <DidGroupRenameInfo />
        </Card.Body>
      </Card>
    </>
  );
};
